<template>
    <inertia-head>
        <title>Bästa rabattkoderna just nu - Topplistan</title>
        <meta name="keywords" :content="`Rabattkoder, Rabattkod, Populära`">
        <meta name="description" :content="`Här hittar du de kampanjer och rabatter som är mest klickade just nu. Välkommen och shoppa loss!`">
        <link rel="canonical" :href="canonical">
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
    </inertia-head>

    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            Topplistan
        </breadcrumb-item>
    </breadcrumb>

    <main role="main" class="main search-results page-content-padding">
        <div>
            <h1 class="page-heading">{{ $t('toplista') }}</h1>

            <p class="text-dark px-2 mx-auto" style="max-width: 800px;">
                <expandable-text :max-length="100" :disabled="!$isMobile">Crème de la crème! Här har vi gjort det enkelt för dig och samlat de kampanjer och rabatter som är mest klickade just nu. Välkommen och shoppa loss! </expandable-text>
            </p>

            <campaigns-loading v-if="results.length === 0"></campaigns-loading>

            <!-- <div>
                {{ hits }}
                <span v-if="hits === 1">träff</span>
                <span v-else>träffar</span>
            </div> -->

            <!-- <a class="mt-2 badge" :class="{'badge-primary': showWebshops, 'badge-secondary': !showWebshops}" @click="showWebshops = !showWebshops, refresh()">E-Handel</a> -->
            <!-- <a class="mt-2 badge" :class="{'badge-primary': showLocals, 'badge-secondary': !showLocals}" @click="showLocals = !showLocals, refresh()">Lokal</a> -->

            <!-- <company-type-filter @changed="refresh()" ref="companyTypeFilter"></company-type-filter>

            <select class="mt-2 badge badge-secondary" v-model="selectedCity" @change="cityChanged">
                <option>Hela landet</option>
                <option v-for="city in cities" :value="city">{{ city.name }}</option>
            </select> -->

            <div class="list-result-container">
                <div class="list-result container">
                    <div class="row gx-3 mt-2">
                        <div class="col-6 col-md-3 mb-4" v-for="campaign in results" :key="campaign.id">
                            <campaign-item
                                :campaign="campaign"
                                :banner="campaign.banner" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import CityFilter from '../mixins/CityFilter';
    import CompanyTypeFilter from '@/components/CompanyTypeFilter.vue';
    import CampaignsLoading from '@/components/loading-states/CampaignsLoading.vue';

    export default {
        props: ['canonical'],
        inject: ['$isMobile'],
        mixins: [CityFilter],
        data() {
            return {
                highlights: [],
                results: [],
                hits: 0,
            };
        },
        async created () {
            this.highlights = await this.$store.dispatch('getHighlightsForPosition', 'toplist');

            this.getToplist().then(response => {
                this.results = [...this.highlights, ...response.data];
                this.hits = this.results.length;
            });
        },
        components: {
            CompanyTypeFilter, CampaignsLoading
        },
        metaInfo() {
            return {
                title: 'Topplistan - Familjekortet'
            };
        },
        methods: {
            getToplist () {
                var selectedCity = (typeof this.selectedCity === 'object') ? this.selectedCity.name : this.selectedCity;

                var showLocals = true;
                var showWebshops = true;

                return axios.get(`/api/v2/toplist?page=${this.page}&webshops=${showWebshops}&locals=${showLocals}&city=${selectedCity}`);
            },
            cityChanged () {
                this.updateCity();
            }
        },
    }
</script>
